<template>
  <div>
    <iframe :src="url" style="border: none" :height="height + 30" width="100%"></iframe>
  </div>
</template>

<script>
import $http from '../request';
export default {
  props: {
    sxtbm: {
      type: String,
      default: '',
    },
    startToPlay: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 200,
    }
  },
  data() {
    return {
      tenantId: sessionStorage.getItem("tenantId"),
      url: ''
    };
  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  methods: {
    getVideoUrl(startTime, endTime) {
      this.url = "";
      $http({
        url: "hls2Video/realConfig",
        method: 'get',
      }).then((res) => {
        let videoUrl = res.data.videoUrl;
        this.url = videoUrl + `ffmpegHistory.html?tenantId=${this.tenantId}&key=${this.sxtbm}` +
          `&startTime=${startTime}&endTime=${endTime}&height=${this.height + 'px'}`
      })
    }
  },
  destroyed() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/common/video/AliPlayerHls2History.vue